import angular from 'angular';
import uiRouter from 'angular-ui-router';
import loansSignUpFormFieldsComponent from './loansSignUpFormFields.component';

let loansSignUpFormFieldsModule = angular.module('loansSignUpFormFields', [
  uiRouter
])

.component('loansSignUpFormFields', loansSignUpFormFieldsComponent)

.name;

export default loansSignUpFormFieldsModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUpForm/loansSignUpFormFields/loansSignUpFormFields.js